"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildImportFailedMockData = exports.buildImportCompletedMockData = exports.buildExportCompletedMockData = void 0;
const organization_facing_base_1 = require("./organization-facing-base");
const buildExportCompletedMockData = ({ locale = "en", subject = "Your export is ready", firstName = "John", url = "https://storage.zeffy.com/exports/mock-export.csv", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    url,
});
exports.buildExportCompletedMockData = buildExportCompletedMockData;
const buildImportCompletedMockData = ({ locale = "en", subject = "Your import is complete", firstName = "John", redirectionUrl = "https://www.zeffy.com/en-US/o/crm/contacts", contactLine = { count: 67, url: "https://www.zeffy.com/en-US/o/crm/contacts" }, memberLine = null, templateLine = {
    count: 12,
    url: "https://www.zeffy.com/en-US/o/communication/bulk-emails/templates?templateFilter=organization",
}, emailLine = { count: 7, url: "https://www.zeffy.com/en-US/o/communication/bulk-emails" }, listLine = { count: 5, url: "https://www.zeffy.com/en-US/o/crm/lists" }, transactionLine = null, } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    redirectionUrl,
    contactLine,
    memberLine,
    templateLine,
    emailLine,
    listLine,
    transactionLine,
});
exports.buildImportCompletedMockData = buildImportCompletedMockData;
const buildImportFailedMockData = ({ locale = "en", subject = "Your import failed", firstName = "John", redirectionUrl = "https://www.zeffy.com/en-US/o/home", hasEmailValidationError = true, } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    redirectionUrl,
    hasEmailValidationError,
});
exports.buildImportFailedMockData = buildImportFailedMockData;
